import Drawer from './src'

Drawer.install = Vue => {
  Vue.component(Drawer.name, Drawer)
}

export default Drawer
